import { Button, Grid, GridCell, Heading, Text } from '@flixbus/honeycomb-react';
import { useTranslation } from 'react-i18next';
import { login } from '../../helpers/auth';
import PageTitle from '../pageTitle/PageTitle';

const LoginMessage = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('buttons.login')} />
            <Grid extraClasses="hcr-space-8-top">
                <GridCell colSpan={12} extraClasses="hcr-has-text-centered">
                    <Heading size={2}>{t('titles.loginTitle')}</Heading>
                    <Text>{t('titles.loginDescription')}</Text>
                    <Button appearance="primary" extraClasses="hcr-space-4-top" onClick={login}>
                        {t('buttons.login')}
                    </Button>
                </GridCell>
            </Grid>
        </>
    );
};

export default LoginMessage;
